// import { useEffect, useState } from "react";
// import { Button, Col, Form, Row } from "react-bootstrap";
// import { useDispatch } from "react-redux";
// import { sendWhatsappTemp, userWiseMessage } from "../../reducers/commonReducer";

// const TemplateInputFields = ({ numberOfInputs, vartype, selectedTemp, setSelectedTemp }) => {
//   const queryParams = new URLSearchParams(window.location.search);
//   let customerId = queryParams.get("customerId");
//   let userId = queryParams.get("userid");
//   const dispatch = useDispatch();
//   const [inputFields, setInputFields] = useState([]);
// console.log("numberOfInputs", numberOfInputs)
//   // Update input fields whenever numberOfInputs changes
//   useEffect(() => {
//     setInputFields((prev) => {
//       const newFields = [...prev];
//       const diff = numberOfInputs - newFields.length;

//       if (diff > 0) {
//         // Add new empty fields
//         return [
//           ...newFields,
//           ...Array.from({ length: diff }, () => ({ type: "text", vartype, text: "" })),
//         ];
//       } else if (diff < 0) {
//         // Remove extra fields
//         return newFields.slice(0, numberOfInputs);
//       }
//       return newFields;
//     });
//   }, [numberOfInputs]);

//   const handleChange = (index, value) => {
//     const updatedFields = [...inputFields];
//     updatedFields[index].text = value;
//     setInputFields(updatedFields);
//   };

//   const handleSave = async () => {
//     const apiRsp = await dispatch(
//       sendWhatsappTemp({
//         tempName: selectedTemp,
//         tempVar: inputFields,
//         userid: customerId
//       })
//     );
//     if(apiRsp?.payload?.status){
//         setInputFields([]);
//         dispatch(userWiseMessage({ userid: userId, page : 0 }));
//         setSelectedTemp('');
//     }
//   };

//   return (
//     <>
//      {selectedTemp ? <>
//      <Row
//         className="flex-nowrap overflow-auto mt-4"
//         style={{ whiteSpace: "nowrap" }}
//       >
//         {inputFields.map((field, index) => (
//           <Col>
//             <Form.Group key={index} className="mb-2">
//               <Form.Control
//                 type="text"
//                 placeholder={`Input ${index + 1}`}
//                 value={field.text}
//                 onChange={(e) => handleChange(index, e.target.value)}
//               />
//             </Form.Group>
//           </Col>
//         ))}
//       </Row>
//       <Button variant="success" onClick={handleSave}>
//         Send Template <i className="bi bi-send-check-fill"></i>
//       </Button>
//       </> : null }
//     </>
//   );
// };

// export default TemplateInputFields;


import { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { sendWhatsappTemp, userWiseMessage } from "../../reducers/commonReducer";

const TemplateInputFields = ({ whtspVarCount, selectedTemp, setSelectedTemp, tempReco, setTempReco }) => {
  const queryParams = new URLSearchParams(window.location.search);
  const customerId = queryParams.get("customerId");
  const userId = queryParams.get("userid");
  const dispatch = useDispatch();

  const [inputFields, setInputFields] = useState({});

  const vartypes = ["HEADER", "BUTTONS", "BODY"]; // Add more types if needed

  useEffect(() => {
    const updatedInputs = {};
    vartypes.forEach((type) => {
      const count = whtspVarCount?.[type]?.inputs || 0;
      const format = whtspVarCount?.[type]?.format || '';
      updatedInputs[type.toLowerCase()] = Array.from({ length: count }, () => ({
        vartype: type,
        text: "",
        type: format
      }));
    });
    setInputFields(updatedInputs);
  }, [whtspVarCount]);

  const handleChange = (vartype, index, value) => {
    setInputFields((prev) => {
      const updated = [...(prev[vartype] || [])];
      updated[index].text = value;
      return { ...prev, [vartype]: updated };
    });
  };

  const handleSave = async () => {
    const allInputs = Object.values(inputFields).flat();
    const apiRsp = await dispatch(
      sendWhatsappTemp({
        tempName: selectedTemp,
        components: tempReco,
        tempVar: allInputs,
        userid: customerId
      })
    );
    if (apiRsp?.payload?.status) {
      setInputFields({});
      dispatch(userWiseMessage({ userid: userId, page: 0 }));
      setSelectedTemp('');
      setTempReco('');
    }
  };
const allInputsFilled = Object.values(inputFields)
  .flat()
  .every((field) => field.text.trim() !== "");

  return selectedTemp ? (
    <>
      {vartypes.map((type, index) => {
        const key = type.toLowerCase();
        const fields = inputFields[key] || [];
        return (
          <div key={key}>
            <h6 className="mt-3"><b>{type} Inputs {inputFields[key]?.[index]?.type}</b></h6>
            <Row className="flex-nowrap overflow-auto mb-2">
              {fields.map((field, index) => (
                <Col key={index}>
                  <Form.Group className="mb-2">
                    <Form.Control
                      required
                      type="text"
                      placeholder={`${type} Input ${index + 1}`}
                      value={field.text}
                      onChange={(e) => handleChange(key, index, e.target.value)}
                    />
                  </Form.Group>
                </Col>
              ))}
            </Row>
          </div>
        );
      })}

      <Button variant="success" onClick={handleSave} disabled={!allInputsFilled}>
        Send Template <i className="bi bi-send-check-fill"></i>
      </Button>
    </>
  ) : null;
};

export default TemplateInputFields;
